import {
	PRODUCT_TYPES,
	PRODUCT_SUBTYPES,
	PRODUCT_SUBTYPE_NAMES,
} from "shared/payment/constants";

function getUnitName(productType, productSubtype) {
	if (productSubtype === PRODUCT_SUBTYPES.BOOST) {
		return { unitName: "Boost", unitNamePlural: "Boosts" };
	}

	else if (productType === PRODUCT_TYPES.SUBSCRIPTION) {
		return { unitName: "Month", unitNamePlural: "Months" };
	}

	else if (productSubtype === PRODUCT_SUBTYPES.READ_RECEIPT) {
		return { unitName: "Read Receipt", unitNamePlural: "Read Receipts" };
	}

	return "";
}

export function formatProductName({
	productType, productSubtype, subPeriod, tokensNumber,
}) {
	const namePrefix = PRODUCT_SUBTYPE_NAMES[productSubtype];
	const { unitName, unitNamePlural } = getUnitName(productType, productSubtype);

	let formattedName;

	if (productType === PRODUCT_TYPES.SUBSCRIPTION) {
		if (subPeriod > 1) {
			formattedName = `${namePrefix}: ${subPeriod} ${unitNamePlural}`;
		} else {
			formattedName = `${namePrefix}: ${subPeriod} ${unitName}`;
		}
	} else if (productSubtype === PRODUCT_SUBTYPES.BOOST
			|| productSubtype === PRODUCT_SUBTYPES.READ_RECEIPT
	) {
		if (tokensNumber > 1) {
			formattedName = `${tokensNumber} ${unitNamePlural}`;
		} else {
			formattedName = `${tokensNumber} ${unitName}`;
		}
	} else if (productSubtype === PRODUCT_SUBTYPES.STACK_PASS) {
		formattedName = namePrefix;
	}

	return formattedName;
}


export default function processProduct(product) {
	const {
		productid: id,
		initialPrice: subtotal,
		initialUnitPrice: unitPrice,
		initialSubtotalPrice: total,
		initialCurrency: currencyCode,
		productType,
		productSubtype,
		initialTaxes = [],
	} = product;

	const { unitName, unitNamePlural } = getUnitName(productType, productSubtype);

	// const taxes = total - subtotal;
	const taxes = initialTaxes.reduce((sum, { taxAmount }) => sum + taxAmount, 0);
	const formattedSalesTaxes = (initialTaxes.find(({ taxType }) => taxType === "SALES") || {}).formattedTaxAmount;


	let name = PRODUCT_SUBTYPE_NAMES[productSubtype];
	let learnMoreLink = null;

	if (productType === PRODUCT_TYPES.SUBSCRIPTION) {
		learnMoreLink = "/legal/subscription";

		if (product.subPeriod > 1) {
			name = `${name}: ${product.subPeriod} ${unitNamePlural}`;
		} else {
			name = `${name}: ${product.subPeriod} ${unitName}`;
		}
	}
	else if (productSubtype === PRODUCT_SUBTYPES.BOOST) {
		learnMoreLink = "/legal/boosts";

		if (product.tokensNumber > 1) {
			name = `${product.tokensNumber} ${unitNamePlural}`;
		} else {
			name = `${product.tokensNumber} ${unitName}`;
		}
	}


	return {
		...product,
		name,
		currencyCode,
		id,
		unitName,
		unitNamePlural,
		unitPrice,
		subtotal,
		taxes,
		total,
		learnMoreLink,
		formattedSalesTaxes,
	};
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/processProduct.js